module.exports = __webpack_public_path__ + "assets/1f51925d95ecfc319f65c37e980fad39.png";